export default function RecoveryCodes({ codes }: { codes: string[] }) {
  const copy = () => { navigator.clipboard?.writeText(codes.join('\n')); };
  const download = () => {
    const blob = new Blob([codes.join('\n')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'valentine-recovery-codes.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  return (
    <div style={{ textAlign: 'left' }}>
      <p style={{ fontSize: '.82rem', color: 'var(--danger)', fontWeight: 600, margin: '0 0 .5rem' }}>
        Save these recovery codes — they are shown only once. Each can be used once if you lose your authenticator.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '.3rem .7rem', fontFamily: 'ui-monospace, Menlo, Consolas, monospace', fontSize: '.85rem', margin: '.5rem 0', userSelect: 'text' }}>
        {codes.map(c => <div key={c}>{c}</div>)}
      </div>
      <div style={{ display: 'flex', gap: '.5rem', marginTop: '.5rem' }}>
        <button type="button" onClick={copy}>Copy</button>
        <button type="button" onClick={download}>Download</button>
      </div>
    </div>
  );
}
